module.exports = __webpack_public_path__ + "static/media/img-4.19d39e20.jpg";